import { Injectable } from "@angular/core";
import { RegLookupControlHelperService } from "./reg-lookup-control-helper.service";
import { IRegLookupResults } from "./results.model";
import { FormControl, FormGroup } from "@angular/forms";
import { RegLookupControlResultsModalListItem } from "./reg-lookup-control-results-modal-item.model";
import { SelectOption } from "../../../../core/interfaces/select-option";
import { isDefined } from "ionic-angular/util/util";

@Injectable()
export class ResultsModalController {

    constructor(protected helper: RegLookupControlHelperService) {

    }

    resultsToFormGroup(results: IRegLookupResults): FormGroup {
        return this.helper.resultsToFormGroup(results);
    }

    getItems(formGroup: FormGroup, results: IRegLookupResults): Array<RegLookupControlResultsModalListItem> {

        return Object.keys(formGroup.controls).map(key => {

            const formControl: FormControl = formGroup.controls[key] as FormControl;
            const label = this.helper.getControlTitleByName(key);
            let options: Array<SelectOption> = [];

            if (isDefined(results[key]) && results[key].length > 1) {
                options = results[key]
                    .filter(field => !!field.value)
                    .map(field => new SelectOption(field.value, field.label));
            }

            return new RegLookupControlResultsModalListItem(label, formControl, options);
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/reglookup/form/results-modal.controller.ts